export const PATH_SIMULATOR = 'simulator'
export const PATH_SUMMARY = 'summary'
export const PATH_ONBOARDING = 'onboarding'

export const ROUTE_ROOT = '/'
export const ROUTE_SIMULATOR = `/${PATH_SIMULATOR}`
export const ROUTE_SUMMARY = `/${PATH_SUMMARY}`
export const ROUTE_ONBOARDING = `/${PATH_ONBOARDING}`
